import { render, staticRenderFns } from "./JobHistory.vue?vue&type=template&id=1155b060&"
import script from "./JobHistory.vue?vue&type=script&lang=js&"
export * from "./JobHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports